import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { getPayloadForClearContext } from '../utils/abandonCartUtils';
import { makePut } from '../utils/makeFetchUtil';
import {
  kytClearContextApiUrlSelector,
} from '../selectors/getContextApiSelectors';
import { MODULE_NAME } from '../constants/modules';

export const clearContextThunk = ({
  reRunContextApi, accountToken,
}) => async (dispatch, getState) => {
  const state = getState();
  const clearContextUrl = kytClearContextApiUrlSelector(state);

  try {
    const { response, correlationId } = await makePut({
      url: clearContextUrl,
      body: getPayloadForClearContext(accountToken),
    });

    if (response?.status !== 200 && response?.status !== 201) {
      await dispatch(
        addErrorToReport({
          collectionMethod: 'Fetch Error',
          moduleID: MODULE_NAME,
          component: 'clearContextThunk',
          fetch: {
            url: clearContextUrl,
            status: response?.status,
            correlationId,
          },
          cause: 'Fetch Error: response was not ok while posting context feedback - Response status was not 200 or 201',
        })
      );
    } else {
      reRunContextApi();
    }
  } catch (error) {
    await dispatch(addErrorToReport(
      error,
      {
        collectionMethod: 'Fetch Error',
        moduleID: MODULE_NAME,
        component: 'clearContextThunk',
        cause: 'Fetch Error: Fetch Failure Error',
      }
    ));
  }
};
